import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import style from '../../styles/pagination.module.scss';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  return (
    <div className={style.pagination}>
      <div className={style.pagination__buttons}>
        <Button
          className="btn-tertiary"
          disabled={currentPage === 1}
          onClick={handlePrevious}
        >
          Prethodna
        </Button>
        <div
          className={`${style.pagination__count} ${style.pagination__count__mobile}`}
        >
          <p>
            Stranica {currentPage} od {totalPages === 0 ? 1 : totalPages}
          </p>
        </div>
        <Button
          className={`btn-tertiary ${style.pagination__nextButton}`}
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={handleNext}
        >
          Sledeća
        </Button>
      </div>
      <div
        className={`${style.pagination__count} ${style.pagination__count__desktop}`}
      >
        <p>
          Stranica {currentPage} od {totalPages === 0 ? 1 : totalPages}
        </p>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
